export class ForgotPasswordPopup {
    constructor(selector) {
        this._selector = selector;
        this.initlialiseSelectors();
        this.attachListeners();
    }

    initlialiseSelectors(){
        this._login_popup = jQuery(this._selector.loginPopup);
        this._link = jQuery(this._selector.link);
        this._form = jQuery(this._selector.form);
        this._popup = jQuery(this._selector.popup);
        this._confirmation = jQuery(this._selector.confirmation);
        this._submit_button = jQuery("input[type=submit]", this._popup);
    }

    attachListeners() {
        const that = this;
        this._link.on('click', function (event) {
            event.stopImmediatePropagation();
            event.preventDefault();
            that.displayPopup();
        })

        this._form.on("ajax:success", function(e, data, status) {
            that.showConfirmation(e.detail[0].message);
        }).on("ajax:error", function(e, xhr, status, error) {
            that.showConfirmation(e.detail[0].message);
        }).on("ajax:complete", function(e) {
            that._form.hide();
            jQuery('#forgot-password-form').hide();
            that._confirmation.show();
        });

        jQuery(".pop-close-btn", this._popup).click(function() {
            that._popup.css({"display":"none"});
        });

        jQuery("input[type=text]", this._popup).on("keyup", function(){
            that.validateForm();
        });
    }

    displayPopup() {
        this.resetForm();
        this._login_popup.removeClass("show");
        this._popup.css({"display":"block"});
        jQuery('.popup', this._popup).css({"display":"block"});
        this._form.show();
        this._confirmation.hide();
        jQuery('#forgot-password-form').show();
    }

    resetForm() {
        jQuery('input[type=text]', this._popup).val("");
        jQuery(".input-wrap input[type=text]").trigger( "input" );
    }

    showConfirmation(message) {
        this._confirmation.show().html(message);
    }

    validateForm() {
        let valid = !this.isBlank(jQuery("#username")) && !this.isBlank(jQuery("#parent_email"));
        valid ? this.enableSubmitButton() : this.disableSubmitButton()
    }

    isBlank(element) {
        return element.val().trim() == "";
    }

    enableSubmitButton() {
        this._submit_button.removeAttr("disabled");
    }

    disableSubmitButton() {
        this._submit_button.attr({"disabled" : "disabled"});
    }

    static setup(selector) {
        new ForgotPasswordPopup(selector);
    }
}